import { render, staticRenderFns } from "./BranchPayment.vue?vue&type=template&id=5bceee0d&scoped=true"
import script from "./BranchPayment.vue?vue&type=script&lang=js"
export * from "./BranchPayment.vue?vue&type=script&lang=js"
import style0 from "./BranchPayment.vue?vue&type=style&index=0&id=5bceee0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bceee0d",
  null
  
)

export default component.exports